import { memo, useEffect, useState } from 'react'
import Container from '../../../components/Container'
import { CircularProgress, Grid2, IconButton, Skeleton, Tab, Tabs, Typography } from '@mui/material'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { Add } from '@mui/icons-material'
import { IBranch, IService } from 'sierra'
import api from '../../../utils/axios'
import ServiceCard from '../../../components/Cards/ServiceCard'
import ServiceCardSkeleton from '../../../components/Skeletons/ServiceCardSkeleton'
import { useApp } from '../../../contexts/AppContext'
import socket from '../../../utils/socket'
import { useAuth } from '../../../hooks/useAuth'



const SystemServices = memo(() => {
    const navigate = useNavigate()
    const location = useLocation()
    const { lang, translate } = useApp()
    const { user } = useAuth()

    const [services, setServices] = useState<IService[] | null>(null)
    const [branches, setBranches] = useState<IBranch[] | null>(null)
    const [selectedBranch, setSelectedBranch] = useState<number | null>(null)

    const fetchBranches = () => {
        api.get('/branches').then(res => {
            setBranches(res.data)
            setSelectedBranch(res.data[0].branch_id)
        }).catch(console.error)
    }

    const fetchServices = () => {
        api.get('/services').then(res => {
            setServices(res.data)
            console.log(res.data);
        }).catch(console.error)
    }

    useEffect(() => {
        fetchServices()
        fetchBranches()
        socket.on("branches_changed", fetchBranches);
        socket.on("services_changed", fetchServices);
        socket.on("translations_changed", fetchBranches);
        socket.on("translations_changed", fetchServices);
        return () => {
            socket.off("branches_changed", fetchBranches);
            socket.off("services_changed", fetchServices);
            socket.off("translations_changed", fetchBranches);
            socket.off("translations_changed", fetchServices);
        }
    }, [])

    return (
        <Grid2 container size={'grow'} spacing={location.pathname.split('/')[3] ? 2 : 0} sx={{ transition: { xs: 'none', lg: location.pathname.split('/')[3] ? 'all 0.8s cubic-bezier(0, 0.5, 0.2, 1)' : 'all 0.5s cubic-bezier(0.6, 0, 0.8, 0.4)' } }}>

            <Grid2 container display={{ xs: location.pathname.split('/')[3] ? 'none' : 'flex', lg: 'flex' }} size={{ xs: location.pathname.split('/')[3] ? 0 : 'grow', lg: 'grow' }} flexDirection={'column'} spacing={2}>

                <Container container size={'auto'} padding={{ xs: 1, sm: 2 }} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                    <Grid2>
                        <Typography variant='h4' fontWeight={'bold'} color='primary'>
                            {translate("Services")}
                        </Typography>
                    </Grid2>
                    <Grid2>
                        {!branches ? <CircularProgress /> : branches.length === 0 ? <></> : <IconButton onClick={() => navigate('create', { state: { branches: branches } })}>
                            <Add />
                        </IconButton>}
                    </Grid2>
                </Container>

                <Container container width={'100%'} padding={2} spacing={2} size='auto' alignItems={'center'}>
                    {
                        !branches ? Array.from({ length: 3 }).map((a, i) => <Grid2 key={i} width={{ xs: 75, sm: 150 }}><Skeleton variant="rounded" width={'100%'} height={50} /></Grid2>) : branches.length === 0 ? <></> :
                            <Grid2>
                                <Tabs variant='scrollable' value={selectedBranch || branches && branches[0].branch_id} onChange={(_, v) => setSelectedBranch(v)} aria-label="basic tabs example">
                                    {branches.map((b, i) =>
                                        <Tab key={i} label={b.branch_name[lang]} value={b.branch_id} />
                                    )}
                                </Tabs>
                            </Grid2>

                    }
                </Container>

                <Container container flexDirection={'column'} overflow={'hidden'} spacing={2} padding={2}>

                    <Grid2 container padding={2} overflow={'auto'}>
                        {!branches || !services || !selectedBranch || !user ?
                            Array.from({ length: 3 }).map((a, i) => <ServiceCardSkeleton key={i} />)
                            : branches.length == 0 || services.length == 0 ? <Typography>No services</Typography> :
                                services
                                    .filter(s => s.branch_id === selectedBranch)
                                    .map((s, i) => <ServiceCard hideButtons={
                                        user.role === 'admin' ? false :
                                            user.role === 'employee' ? true :
                                                user.role === 'manager' ?
                                                    branches.find(b => b.branch_id === s.branch_id)?.branch_managers.includes(user.user_id) ? false : true
                                                    : false
                                    } branches={branches} key={i} service={s} branch={branches.find(b => b.branch_id === s.branch_id)} />)}
                    </Grid2>
                    {/* <Grid2 size={'grow'} /> */}
                </Container>

            </Grid2>

            <Grid2 container size={location.pathname.split('/')[3] ? 'grow' : 0} flexGrow={location.pathname.split('/')[3] ? 2 : 0} sx={{ transition: { xs: 'none', lg: 'all 0.5s ease' } }} flexDirection={'column'}
            // gap={openAssignManagers ? 2 : 0} 
            >
                <Container >
                    <Outlet
                    // context={{ setOpenAssignManagers }} 
                    />
                </Container>
                {/* <Container size={openAssignManagers ? 'grow' : 0} sx={{ transition: 'all 0.5s ease' }}>
                    {openAssignManagers && location.pathname.split('/')[3] && <AssignManagers setOpenAssignManagers={setOpenAssignManagers} />}
                </Container> */}
            </Grid2>

        </Grid2>
    )
})

export default SystemServices